import { SofaModule } from './objects/SofaModule';
import { ProjectRenderer } from './ProjectRenderer';
import { SerializedRenderer } from './types';

export class CollectionBuilder {
	constructor(private renderer: ProjectRenderer) {}

	async buildCollection(snapshot: SerializedRenderer) {
		this.renderer.moduleManager.clearCollection();

		const sofaModules = await Promise.all(
			snapshot.modulesManager.sofaModules.map(
				(moduleData) =>
					new Promise<SofaModule>((resolve) => {
						resolve(this.renderer.moduleManager.addFromData(moduleData));
					})
			)
		);

		for (const sofaModule of sofaModules) {
			this.renderer.moduleManager.addModuleToCollection(sofaModule);
		}

		const allSlots = this.renderer.moduleManager.getAllSlots();

		for (const moduleData of snapshot.modulesManager.sofaModules) {
			for (const slotData of moduleData.connectingSlots) {
				if (!slotData.connectedSlot) continue;

				const slotA = allSlots.find((slot) => slot.id === slotData.id);
				const slotB = allSlots.find(
					(slot) => slot.id === slotData.connectedSlot
				);
				if (!slotA || !slotB) continue;

				slotA.connectTo(slotB);
			}
		}

		this.renderer.modulesChangeSideEffects();
		this.renderer.handleCameraCenter();
		this.renderer.moduleManager.setOrder();
	}
}
